import React from 'react';

import Icon from '../../Icon/Icon';
import styles from './MomentOfDelightIcon.module.scss';

const MomentOfDelightIcon = () => {
    return (
        <Icon width='84' height='100' viewBox='0 0 84 100' className={styles.IconContainer}>
            <path d='M16.935 95.86L24.16 100L36.29 79.14L29.067 75L16.935 95.86Z' fill='#FFD040' />
            <path d='M0 92.634L7.223 96.774L19.355 75.914L12.131 71.774L0 92.634Z' fill='#DB3624' />
            <path d='M33.065 84.491L40.202 88.71L49.194 72.767L42.056 68.548L33.065 84.491Z' fill='#287BAF' />
            <path d='M16.129 82.15L23.352 86.29L35.484 65.43L28.26 61.29L16.129 82.15Z' fill='#E3813B' />
            <path d='M0.806 74.085L8.03 78.225L20.16 57.367L12.937 53.227L0.806 74.085Z' fill='#922C20' />
            <path d='M49.194 74.007L56.331 78.226L65.323 62.283L58.185 58.065L49.194 74.007Z' fill='#00D1D2' />
            <path d='M31.452 70.86L38.675 75L50.806 54.14L43.583 50L31.452 70.86Z' fill='#FFD040' />
            <path d='M17.742 61.91L24.88 66.129L33.871 50.186L26.733 45.968L17.742 61.91Z' fill='#DB3624' />
            <path d='M47.58 58.685L54.718 62.903L63.708 46.96L56.571 42.742L47.58 58.685Z' fill='#287BAF' />
            <path d='M33.87 51.427L41.008 55.645L50 39.702L42.862 35.484L33.87 51.427Z' fill='#E3813B' />
            <path d='M19.355 42.634L26.578 46.774L38.71 25.914L31.486 21.774L19.355 42.634Z' fill='#922C20' />
            <path d='M63.71 48.28L70.933 52.42L83.065 31.56L75.841 27.42L63.71 48.28Z' fill='#00D1D2' />
            <path d='M50 40.136L57.138 44.355L66.129 28.412L58.991 24.194L50 40.136Z' fill='#FFD040' />
            <path d='M35.484 31.265L42.622 35.484L51.612 19.541L44.475 15.323L35.484 31.265Z' fill='#DB3624' />
            <path d='M66.128 28.846L73.266 33.065L82.257 17.122L75.119 12.903L66.128 28.846Z' fill='#287BAF' />
            <path d='M51.613 20.86L58.836 25L70.968 4.14L63.745 0L51.613 20.86Z' fill='#E3813B' />
        </Icon>
    );
};

export default MomentOfDelightIcon;
